interface BadgeProps {
  variant: "success" | "warning" | "error" | "info" | "neutral" | "default";
  children: React.ReactNode;
  size?: "sm" | "md";
}

const variantClasses = {
  success: "bg-emerald-100 text-emerald-700 border border-emerald-200",
  warning: "bg-amber-100 text-amber-700 border border-amber-200",
  error: "bg-red-100 text-red-700 border border-red-200",
  info: "bg-sky-100 text-sky-700 border border-sky-200",
  neutral: "bg-gray-100 text-gray-600 border border-gray-200",
  default: "bg-gray-100 text-gray-600 border border-gray-200",
};

export default function Badge({ variant, children, size = "md" }: BadgeProps) {
  return (
    <span
      className={`inline-flex items-center rounded-full font-medium whitespace-nowrap ${variantClasses[variant]} ${
        size === "sm" ? "px-2 py-0.5 text-xs" : "px-2.5 py-1 text-xs"
      }`}
    >
      {children}
    </span>
  );
}
